export default __webpack_public_path__ + "img/zumperDarkText.664a5ef8.svg";